import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { navigationConfigMenu } from "configs/NavigationConfig";
import IntlMessage from 'components/util-components/IntlMessage';

// Built fresh from the role-filtered nav (not cached at module scope) so a
// restricted role like partner_admin never sees titles/links for pages that
// have been filtered out of navigationConfigMenu().
const buildBreadcrumbData = () => {
	const breadcrumbData = {
		'/app' : <IntlMessage id="home" />
	};
	navigationConfigMenu().forEach((elm) => {
		const assignBreadcrumb = (obj) => breadcrumbData[obj.path] = <IntlMessage id={obj.title} />;
		assignBreadcrumb(elm);
		if (elm.submenu) {
			elm.submenu.forEach( elm => {
				assignBreadcrumb(elm)
				if(elm.submenu) {
					elm.submenu.forEach( elm => {
						assignBreadcrumb(elm)
					})
				}
			})
		}
	})
	return breadcrumbData;
}

const BreadcrumbRoute = withRouter(props => {
	const { location } = props;
	const breadcrumbData = buildBreadcrumbData();
	const pathSnippets = location.pathname.split('/').filter(i => i);
	const buildBreadcrumb = pathSnippets.map((_, index) => {
		const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
		return (
		<Breadcrumb.Item key={url}>
			<Link to={url}>{breadcrumbData[url]}</Link>
		</Breadcrumb.Item>
		);
	});
  
  return (
		<Breadcrumb>
			{buildBreadcrumb}
		</Breadcrumb>
  );
});

export class AppBreadcrumb extends Component {
	render() {
		return (
			<BreadcrumbRoute />
		)
	}
}

export default AppBreadcrumb
